<template>
  <div class="summary">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    >
    </loading>
    <h1></h1>
    <checkout />
    <shopping-cart />
    <div class="col-sm-6 input-group mb-3 total-order-summary">
      <div class="form-group col-md-12">
        <label for="net">{{ $t("basket.netAmount") }}</label>
        <input
          id="net"
          disabled="disabled"
          type="text"
          class="form-control total-order-summary"
          :value="currencyDisplay(totalPrice, false)"
          placeholder="Kwota netto"
        />
      </div>
      <!-- <div class="form-group col-md-12">
        <label for="vat"> {{ $t("basket.tax") }}</label>
        <input
          id="vat"
          disabled="disabled"
          type="text"
          class="form-control total-order-summary"
          :value="
            checkFreeTax
              ? currencyDisplay(totalPrice * 1.23 - totalPrice, false)
              : 0
          "
          placeholder="Podatek"
        />
      </div> -->
      <!-- <div class="form-group col-md-12">
        <label for="gross">{{ $t("basket.grossAmount") }}</label>
        <input
          id="gross"
          disabled="disabled"
          type="text"
          class="form-control total-order-summary"
          :value="
            checkFreeTax
              ? currencyDisplay(totalPrice * 1.23, false)
              : currencyDisplay(totalPrice, false)
          "
          placeholder="Podatek"
        />
      </div> -->
    </div>
    <div class="col-sm-12">
      <div class="col">
        <div class="text-center">
          <router-link to="/cart" class="btn btn-secondary m-1">
            {{ $t("buttons.back") }}
          </router-link>
          <button
            class="btn btn-success m-1"
            @click="submitOrder"
            v-if="order.status === 'new'"
          >
            {{ $t("buttons.beginOrder") }}
          </button>
          <button
            class="btn btn-success m-1"
            @click="submitOrder"
            v-else-if="order.status === 'edit'"
          >
            {{ $t("buttons.editOrder") }}
          </button>
          <button
            class="btn btn-success m-1"
            @click="submitOrder"
            v-else-if="order.status === 'create'"
          >
            {{ $t("buttons.createInvoice") }}
          </button>
          <button
            class="btn btn-success m-1"
            @click="submitOrder"
            v-else-if="order.status === 'createInvoice'"
          >
            {{ $t("buttons.createInvoice") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { currencyMixin } from "../mixins";
import ShoppingCart from "./ShoppingCart.vue";
import Checkout from "./Checkout.vue";
import Countries from "../enums/CountriesEuropeanUnion";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Summary",
  data() {
    return {
      isLoading: false,
      fullPage: true,
    };
  },
  components: { ShoppingCart, Checkout, Loading },
  mixins: [currencyMixin],
  computed: {
    ...mapState("cart", ["order"]),
    ...mapGetters("cart", ["totalPrice", "transport", "currentCustomer"]),
    checkFreeTax() {
      let vat = this.$store.state.customers.customer.vat;
      vat = vat.substring(0, 2);
      if (Countries.includes(vat)) return false;
      return true;
    },
  },
  methods: {
    ...mapActions({
      storeOrder: "orders/storeOrder",
      clearCart: "cart/clearCartData",
    }),
    ...mapMutations("cart", [
      "setPayment",
      "setShipping",
      "setComment",
      "setShippingValue",
      "setProposalTime",
      "setPrepayment",
      "setShippingCity",
      "setCleanCart",
    ]),
    async submitOrder() {
      this.isLoading = true;
      let order = await this.storeOrder(this.order);
      this.isLoading = false;
      if (
        order.data[0].message == "OK" ||
        order.data[0].message == "EDIT" ||
        order.data[0].message == "CREATE"
      ) {
        this.$store.commit("cart/setCleanCart", []);
        this.$store.commit("cart/setCartData", []);
        localStorage.removeItem("cart");
        // this.setCleanCart();
        this.$router.push("/customers");
      }
    },
  },
};
</script>
